import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import moment from 'moment';
import { formatDate } from 'utils/formatters/Date';
import { titleize } from 'underscore.string';
import { formattedLastSeen, formatPlatformLabel, } from 'utils/localization/utils';
import CargomaticCard from '../../../v2/card';
import ConfirmModal from '../../../ui/modals/ConfirmModal';
class DriverList extends Component {
    constructor(props) {
        super(props);
        this.handleAddDefaultDriver = () => this.props.onAddDefaultDriver();
        this.handleHideConfirmModal = () => this.setState({
            showConfirmModal: false,
        });
        this.handleConfirmDefaultDriver = () => {
            const { defaultDriverId, defaultDriverVal } = this.state;
            if (defaultDriverVal === 'true') {
                this.props.onMakeDefault(defaultDriverId);
            }
            this.setState({
                defaultDriverId: null,
                defaultDriverVal: null,
                showConfirmModal: false,
            });
        };
        this.handleDefaultDriverChange = (driverId) => (e) => this.setState({
            showConfirmModal: true,
            defaultDriverId: driverId,
            defaultDriverVal: e.target.value,
        });
        this.state = {
            showConfirmModal: false,
            defaultDriverId: null,
            defaultDriverVal: null,
        };
    }
    getClientPlatform(driver) {
        let platform = 'Unknown';
        if (driver.client_platform) {
            platform = driver.client_platform;
            if (driver.client_version) {
                platform += ' v' + driver.client_version;
            }
        }
        return platform;
    }
    getDefaultDriverButtonState() {
        if (this.props.defaultDriver) {
            return true;
        }
        return false;
    }
    getEquipmentClass(driver) {
        const { t } = this.props;
        if (driver.equipment_class)
            return titleize(t(driver.equipment_class.label));
        return titleize(t('UNKNOWN'));
    }
    updateDriverOffersBeforePickup(driverId) {
        return (e) => {
            this.props.onUpdateDriver({
                _id: driverId,
                can_accept_offers_before_pickup: e.target.value,
            });
        };
    }
    updateDriverReceiveOffers(driverId) {
        return (e) => {
            this.props.onUpdateDriver({
                _id: driverId,
                receive_offers: e.target.value,
            });
        };
    }
    bool(value) {
        const { t } = this.props;
        let text;
        let className;
        if (value) {
            text = 'YES';
            className = 'driverBoolTrue';
        }
        else {
            text = 'NO';
            className = 'driverBoolFalse';
        }
        return React.createElement("span", { className: className }, t(text));
    }
    render() {
        const { t } = this.props;
        let drivers;
        const allDrivers = this.props.drivers.map((driver) => {
            const url = '/users/' + driver._id;
            const createdAt = (driver === null || driver === void 0 ? void 0 : driver.created_at) ? formatDate(driver === null || driver === void 0 ? void 0 : driver.created_at, {
                dateFormat: DEFAULT_DATE_FORMAT,
                timeFormat: DEFAULT_TIME_FORMAT,
                timezone: DEFAULT_TIMEZONE,
                showTimezone: false,
                t,
            }) : '';
            return (React.createElement("tr", { className: "driverListItem", key: driver._id },
                React.createElement("td", { className: "p-4 text-sm font-medium text-gray-500" },
                    React.createElement("a", { href: url }, driver.first_name + ' ' + driver.last_name)),
                React.createElement("td", { className: "p-4 text-sm font-medium text-gray-500" }, driver.username),
                React.createElement("td", { className: "p-4 text-sm font-medium text-gray-500" }, this.bool(driver.authorized)),
                React.createElement("td", { className: "p-4 text-sm font-medium text-gray-500" }, createdAt),
                React.createElement("td", { className: "p-4 text-sm font-medium text-gray-500" }, formattedLastSeen(moment(driver.last_check_in).fromNow())),
                React.createElement("td", { className: "p-4 text-sm font-medium text-gray-500" }, formatPlatformLabel(this.getClientPlatform(driver))),
                React.createElement("td", { className: "p-4 text-sm font-medium text-gray-500" }, this.getEquipmentClass(driver)),
                React.createElement("td", { className: "p-4 text-sm font-medium text-gray-500" },
                    React.createElement("select", { className: "form-select", defaultValue: driver.can_accept_offers_before_pickup || false, onChange: this.updateDriverOffersBeforePickup(driver._id) },
                        React.createElement("option", { value: "false" }, t('NO')),
                        React.createElement("option", { value: "true" }, t('YES')))),
                React.createElement("td", { className: "p-4 text-sm font-medium text-gray-500" },
                    React.createElement("select", { className: "form-select", defaultValue: driver.receive_offers || false, onChange: this.updateDriverReceiveOffers(driver._id) },
                        React.createElement("option", { value: "false" }, t('NO')),
                        React.createElement("option", { value: "true" }, t('YES')))),
                React.createElement("td", { className: "p-4 text-sm font-medium text-gray-500" },
                    React.createElement("select", { className: "form-select", value: this.props.defaultDriver === driver._id, onChange: this.handleDefaultDriverChange(driver._id) },
                        React.createElement("option", { value: "false" }, t('NO')),
                        React.createElement("option", { value: "true" }, t('YES'))))));
        });
        if (!allDrivers.length) {
            drivers = (React.createElement("div", { className: "noDrivers" }, t('CARRIER_HAS_NO_DRIVERS', { carrier: this.props.carrier })));
        }
        else {
            drivers = (React.createElement("table", { className: "min-w-full divide-y divide-gray-200" },
                React.createElement("thead", { className: "bg-gray-50" },
                    React.createElement("tr", null,
                        React.createElement("th", { className: "p-4 text-xs font-medium tracking-wider text-gray-500" }, t('NAME')),
                        React.createElement("th", { className: "p-4 text-xs font-medium tracking-wider text-gray-500" }, t('USERNAME')),
                        React.createElement("th", { className: "p-4 text-xs font-medium tracking-wider text-gray-500" }, t('AUTHORIZED')),
                        React.createElement("th", { className: "p-4 text-xs font-medium tracking-wider text-gray-500" }, t('CREATED_DATE')),
                        React.createElement("th", { className: "p-4 text-xs font-medium tracking-wider text-gray-500" }, t('LAST_SEEN')),
                        React.createElement("th", { className: "p-4 text-xs font-medium tracking-wider text-gray-500" }, t('PLATFORM', { count: 1 })),
                        React.createElement("th", { className: "p-4 text-xs font-medium tracking-wider text-gray-500" }, t('EQUIPMENT_CLASS')),
                        React.createElement("th", { className: "p-4 text-xs font-medium tracking-wider text-gray-500" }, t('MULTI_PICKUPS')),
                        React.createElement("th", { className: "p-4 text-xs font-medium tracking-wider text-gray-500" }, t('RECEIVE _OFFERS_QUE')),
                        React.createElement("th", { className: "p-4 text-xs font-medium tracking-wider text-gray-500" }, t('DEFAULT')))),
                React.createElement("tbody", null, allDrivers)));
        }
        return (React.createElement(CargomaticCard, { className: "driverList", header: () => (React.createElement("div", { className: "flex items-center justify-between" },
                React.createElement("h3", { className: "my-0 mr-2" }, t('DRIVER', { count: 1 })),
                React.createElement("button", { disabled: this.getDefaultDriverButtonState(), className: "button button-hollow-green", onClick: this.handleAddDefaultDriver },
                    React.createElement("i", { className: "mr-2 fa fa-plus" }),
                    t('DEFAULT_DRIVER')))), removeHorizontalPadding: true, removeVerticalPadding: true },
            React.createElement("div", { className: "overflow-x-auto" }, drivers),
            React.createElement(ConfirmModal, { show: this.state.showConfirmModal, message: t('CHANGE_DEFAULT_DRIVER_MSG'), onHide: this.handleHideConfirmModal, onConfirm: this.handleConfirmDefaultDriver })));
    }
}
export default withTranslation()(DriverList);
DriverList.propTypes = {
    carrier: PropTypes.object,
    drivers: PropTypes.array,
    defaultDriver: PropTypes.shape({
        _id: PropTypes.string,
    }),
    onAddDefaultDriver: PropTypes.func.isRequired,
    onMakeDefault: PropTypes.func.isRequired,
    onUpdateDriver: PropTypes.func.isRequired,
};
